import {
	SET_LIST_CAMPAIGN_ACTION,
	SET_CAMPAIGN_DETAIL_ACTION,
	SET_LOYALTY_DETAIL_ACTION,
	SET_MERCHANDISING_DETAIL_ACTION,
	SET_LOYALTY_POINT_DETAIL_ACTION,
	SET_MENU_PROMOTION_ACTION
} from "../actions/SpecialOfferPageAction/actionTypes";

const initialState = {
	listCampaign: [],
	listLoyalty: [],
	listMerchandising: [],
	campaignDetail: {},
	loyaltyDetail: {},
	merchandisingDetail: {},
	loyaltyPointDetail: {},
	menuPromotionAction: 0
};

// Receive signal of action -> return new state
const specialOfferPageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LIST_CAMPAIGN_ACTION: {
			return {
				...state,
				listCampaign: action.params.campaigns,
				listLoyalty: action.params.loyaltys,
				listMerchandising: action.params.merchandisings
			};
		}
		case SET_CAMPAIGN_DETAIL_ACTION: {
			return {
				...state,
				campaignDetail: action.params.campaign
			};
		}
		case SET_LOYALTY_DETAIL_ACTION: {
			return {
				...state,
				loyaltyDetail: action.params.detail ? action.params.detail : {}
			};
		}
		case SET_MERCHANDISING_DETAIL_ACTION: {
			return {
				...state,
				merchandisingDetail: action.params.detail
					? action.params.detail
					: {}
			};
		}
		case SET_LOYALTY_POINT_DETAIL_ACTION: {
			return {
				...state,
				loyaltyPointDetail: action.params.detail
			};
		}
		case SET_MENU_PROMOTION_ACTION: {
			return {
				...state,
				menuPromotionAction: action.params
			};
		}
		default:
			return state;
	}
};

export default specialOfferPageReducer;
